import { createFileRoute } from '@tanstack/react-router';
import { AreaDetail } from '@/components/Admin/AreaDetail/AreaDetail';

export const Route = createFileRoute('/_adminLayout/admin/areas/$areaSlug/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { areaSlug } = Route.useParams();
  return <AreaDetail areaSlug={areaSlug} />;
}
